import styled from '@emotion/styled';
import { fonts } from '@theme/fontsCustomer';

export const NoDataText = styled.p`
  ${fonts.Body2}
  margin-bottom: 4px;
`;
